import { m } from "@/paraglide/messages.js";
import { getLocale } from "@/paraglide/runtime.js";

/** Minor units in the reader's locale: 40000 PLN is "400,00 zł". */
export const money = (amount: number, currency: string) =>
  new Intl.NumberFormat(getLocale(), { style: "currency", currency }).format(amount / 100);

export const formatDate = (iso: string) => new Intl.DateTimeFormat(getLocale(), { dateStyle: "medium" }).format(new Date(iso));

/** "400,00 zł / mies." for a subscription, the plain price for anything bought once. */
export const offerPrice = (offer: { priceAmount: number; currency: string; interval: string | null; intervalCount: number }) => {
  const price = money(offer.priceAmount, offer.currency);
  if (offer.interval === "month")
    return offer.intervalCount === 1 ? m.offers_per_month({ price }) : m.offers_per_months({ price, count: String(offer.intervalCount) });
  if (offer.interval === "week")
    return offer.intervalCount === 1 ? m.offers_per_week({ price }) : m.offers_per_weeks({ price, count: String(offer.intervalCount) });
  return price;
};
